import React, {MouseEvent} from "react"
import classNames from "classnames";
import styles from '../css/Button.module.css'
import LoadingSpinner from "../components/LoadingSpinner";
import Box from "./Box";

export interface Props {
    children?: React.ReactNode,
    primary?: boolean
    disabled?: boolean,
    clear?: boolean,
    xs?: boolean
    isLoading?: boolean
    alert?: boolean,
    maxWidth?: number,
    showBadge?: boolean,
    className?: string,
    minWidth?: number,
    onClick?: (event: MouseEvent) => void,
    onMouseOver?: (event: MouseEvent) => void,
    onMouseOut?: (event: MouseEvent) => void
}

export default (props: Props) => {

    const {className, showBadge, isLoading, maxWidth, minWidth, xs, children, primary, alert, clear, disabled, onClick, onMouseOut, onMouseOver} = props;
    const style = maxWidth || minWidth ? {maxWidth, minWidth} : undefined;

    return (
        <>
            <button
                onMouseOut={onMouseOut}
                onMouseOver={onMouseOver}
                onClick={onClick}
                disabled={disabled || isLoading}
                style={style}
                className={classNames(styles.button, {
                    [styles.buttonPrimary]: primary,
                    [styles.buttonAlert]: alert,
                    [styles.buttonDisabled]: disabled,
                    [styles.buttonXs]: xs,
                    [styles.buttonClear]: clear,
                    [styles.containBadge]: showBadge,
                }, className)}>

                {showBadge && <span className={styles.badge}/>}

                {isLoading ? <Box center shrink><LoadingSpinner primary/></Box> : children}
            </button>
        </>
    )
}
